import React, { useState, useContext, useMemo, useCallback } from "react";

export type DataContextProps = {
  staff: StaffMember[] | undefined;
  setStaff: (members: StaffMember[] | undefined) => void;
  getStaffMember: (slug?: string | null) => StaffMember | undefined;
};

const DataContext = React.createContext<DataContextProps>(
  {} as DataContextProps,
);

const DataProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const [staffStore, setStaffStore] = useState<StaffMember[] | undefined>();

  const getStaffMember = useCallback(
    (slug?: string | null): StaffMember | undefined =>
      staffStore?.find(({ slug: staffSlug }) => slug && staffSlug === slug),
    [staffStore],
  );

  const value = useMemo<DataContextProps>(
    () => ({
      staff: staffStore,
      setStaff: setStaffStore,
      getStaffMember,
    }),
    [staffStore, setStaffStore, getStaffMember],
  );

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export default DataContext;

export { DataProvider };

export const useData = () => useContext(DataContext);
